import DeviceDetail from './DeviceDetail.vue';
import DeviceDetailSummary from './detail/DeviceDetailSummary.vue';
import DeviceDetailSoftware from './detail/DeviceDetailSoftware.vue';
import DeviceDetailFeatures from './detail/DeviceDetailFeatures.vue';
import DeviceDetailActivity from './detail/DeviceDetailActivity.vue';
import DeviceDetailGroups from './detail/DeviceDetailGroups.vue';
import DeviceCreate from './create/DeviceCreate.vue';

export default function DeviceRoutes() {
  return [
    {
      path: ':id',
      component: DeviceDetail,
      children: [
        {
          path: 'overview',
          component: DeviceDetailSummary,
          name: 'deviceOverview'
        },
        {
          path: 'features',
          component: DeviceDetailFeatures,
          name: 'deviceFeatures'
        },
        {
          path: 'software',
          component: DeviceDetailSoftware,
          name: 'deviceSoftware'
        },
        {
          path: 'groups',
          component: DeviceDetailGroups,
          name: 'deviceGroups'
        },
        {
          path: 'metrics',
          component: DeviceDetailSummary,
          name: 'deviceMetrics'
        },
        {
          path: 'activity',
          component: DeviceDetailActivity,
          name: 'deviceActivity'
        },
        {
          path: 'support',
          component: DeviceDetailSummary,
          name: 'deviceSupport'
        }
      ]
    },
    {
      path: 'create',
      component: DeviceCreate,
      name: 'deviceCreate',
      meta: {
        detail: true
      }
    }
  ]
}
